/* eslint-disable no-undef */
import axios from 'axios';

const actions = {
  async getUSBProducts(context) {
    const getUSBProductsEndpoint = process.env.VUE_APP_URL + '/USBLicense/GetUSBProducts';
    const response = await axios.get(getUSBProductsEndpoint);
    if(response.status === 200) {
      context.commit('setUSBProducts', await response.data);
    } else {
      const error = new Error(response.message);
      throw error;
    }
  },
  async getLicenseTexts(context) {
    const getUSBLicenseTextsEndpoint = process.env.VUE_APP_URL + '/USBLicense/GetUSBLicenseAgreement';
    const response = await axios.get(getUSBLicenseTextsEndpoint);
    if(response.status === 200) {
      context.commit('setUSBLicenseTexts', await response.data);
    } else {
      const error = new Error(response.message);
      throw error;
    }
  },
  async updateUSBFormData(context, payload) {
    const usbPostEndpoint = process.env.VUE_APP_URL + '/USBLicense';
    const response = await axios.post(usbPostEndpoint, payload, {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }).catch(function () {
      context.commit('setAPIError', true);
    });
    if(response?.status === 202 || response?.status === 201 || response?.status === 200) {
      context.commit('setDBUpdateStatus', await response.data);
      context.commit('setAPIError', false);
      $('#alert-message')[0].innerHTML = response.data.alertMessage;
      $("#usb-success-ok").prop("name", response.data.redirectUrl);
      $("#usb-success-modal").modal('show');
    } else {
      context.commit('setAPIError', true);
    }
  },
  async resetDBResponse(context) {
    context.commit('resetDBResponse', {});
  }
};

export default actions;